// extracted by mini-css-extract-plugin
export default {"error":"TextArea_error__2F+aQ"};